import { useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  FileText,
  Users,
  UserPlus,
  IdCard,
  UserCog,
  AlertTriangle,
  Wallet,
  Bell,
  FileSearch,
  BarChart3,
  FolderOpen,
  MessageSquare,
  Clock,
  Settings,
  Monitor,
  List,
  GitBranch,
  Receipt,
  Sliders,
  LucideIcon
} from 'lucide-react';

interface PageInfo {
  label: string;
  icon: LucideIcon;
}

const pathToPageInfo: Record<string, PageInfo> = {
  'main': { label: '현황판', icon: LayoutDashboard },
  'orderStatusByItem': { label: '주문별 현황판', icon: FileText },
  'orderStatus': { label: '회원별 주문현황', icon: Users },
  'memberList': { label: '회원목록', icon: UserPlus },
  'registerStatus': { label: '회원가입신청현황', icon: IdCard },
  'manageRecommender': { label: '추천인 목록', icon: List },
  'recommenderHierarchy': { label: '계층 구조관리', icon: GitBranch },
  'recommenderFeePreset': { label: '수수료 프리셋', icon: Receipt },
  'recommenderSettlementConfig': { label: '정산 설정', icon: Sliders },
  'checkAbuse': { label: '이상거래 감지', icon: AlertTriangle },
  'depositNWithdrawalStatus': { label: '입출금신청현황', icon: Wallet },
  'depositNotice': { label: '입금 공지사항', icon: Bell },
  'depositNWithdrawalInquiry': { label: '입출금내역조회', icon: FileSearch },
  'depositNWithdrawal': { label: '입출금통계', icon: BarChart3 },
  'totalProfitNLoss': { label: '전체손익내역', icon: FolderOpen },
  'recommendedProfitNLoss': { label: '추천인별 손익내역', icon: FolderOpen },
  'memberTotalProfitNLoss': { label: '회원 총손익 집계내역', icon: FolderOpen },
  'memberDailyProfitNLoss': { label: '회원 일별손익내역', icon: FolderOpen },
  'orderSignedHistory': { label: '주문체결내역', icon: FolderOpen },
  'memberOrderHistory': { label: '클라이언트 로그', icon: FolderOpen },
  'MemberAccountBalanceReviseHistory': { label: '회원담보금보정내역', icon: FolderOpen },
  'liveTimeLoginHistory': { label: '실시간 접속내역', icon: Monitor },
  'loginHisotryInquiry': { label: '회원접속이력 조회', icon: FolderOpen },
  'notice': { label: '공지사항', icon: Bell },
  'customerInquiry': { label: '1:1 문의관리', icon: MessageSquare },
  'managerLoginHistory': { label: '관리자 접속 이력조회', icon: FolderOpen },
  'managerWorkHistory': { label: '관리자 작업 이력조회', icon: FolderOpen },
  'manageDepositAccount': { label: '입금계좌관리', icon: Wallet },
  'manageDomestic': { label: '거래종목관리(국내)', icon: Settings },
  'manageForeign': { label: '거래종목관리(해외)', icon: Settings },
  'manageDomesticTradingTime': { label: '거래시간관리(국내)', icon: Clock },
  'manageForeignTradingTime': { label: '거래시간관리(해외)', icon: Clock },
  'changePassword': { label: '비밀번호변경', icon: Settings },
};

export default function Header() {
  const location = useLocation();

  // Extract the current path segment from /dashboard/{path}
  const pathSegments = location.pathname.split('/');
  const currentPath = pathSegments[pathSegments.length - 1] || 'main';

  const pageInfo = pathToPageInfo[currentPath] || { label: '현황판', icon: LayoutDashboard };
  const Icon = pageInfo.icon;

  return (
    <header className="h-14 bg-white border-b border-gray-200 flex items-center px-6">
      <div className="flex items-center space-x-3">
        <Icon className="w-5 h-5 text-blue-600" />
        <h1 className="text-lg font-semibold text-gray-900">{pageInfo.label}</h1>
      </div>
    </header>
  );
}
